module.exports = __webpack_public_path__ + "img/img-ticket-0.97b8e8c3.png";